import Home from "pages/home";
import AboutUs from "pages/AboutUs";
import ContactUs from "pages/ContactUs";
import FAQ from "pages/FAQ";
import HowItWorks from "pages/HowItWorks";
import ChangeEmailAddress from "pages/MyAccount/ChangeEmailAddress";
import ChangePassword from "pages/MyAccount/ChangePassword";
import ChangePhoneNumber from "pages/MyAccount/ChangePhoneNumber";
import CuverdSettings from "pages/MyAccount/CuverdSettings";
import ForgotPassword from "pages/MyAccount/ForgotPassword";
import ForgotVerifyPassword from "pages/MyAccount/ForgotVerifyPassword";
import Mycoupons from "pages/MyAccount/Mycoupons";
import NotificationsList from "pages/MyAccount/NotificationsList";
import Profile from "pages/MyAccount/Profile";
import Settings from "pages/MyAccount/Settings";
import SignInView from "pages/MyAccount/SignInView";
import SignUp from "pages/MyAccount/SignUp";
import VerifyPassword from "pages/MyAccount/VerifyPassword";
import PrivacyPolicy from "pages/PrivacyPolicy";
import SearchMedication from "pages/SearchMedication";
import SelectedCouponDetails from "pages/SearchMedication/SelectedCouponDetails";
import SiteMap from "pages/SiteMap";
import TermsConditions from "pages/TermsConditions";
import { CUVERD } from "./AppConstants";
import PrescriptionsComponent from "pages/PrescriptionsComponent";
const SIGNIN_ROUTES = [];
const SAVINGS_ROUTES = [];

export const CuverdRoutes = [
  {
    path: "/SearchMedication",
    exact: true,
    component: SearchMedication,
  },
  {
    path: "/SearchMedication/:name",
    exact: true,
    component: SearchMedication,
  },
  {
    path: "/SearchMedication/:name/:urlProductDetailId/:urlQuantity",
    exact: true,
    component: SearchMedication,
  },
  {
    path: "/how-cuverd-works",
    exact: true,
    component: HowItWorks,
  },
  {
    path: "/frequently-asked-questions",
    exact: true,
    component: FAQ,
  },
  {
    path: "/Notifications",
    exact: true,
    component: NotificationsList,
    isSecure: true,
  },
  {
    path: "/MyAccount/MyCoupons",
    exact: true,
    component: Mycoupons,
    isSecure: true,
  },
  {
    path: "/MyAccount/Settings",
    exact: true,
    component: Settings,
    isSecure: true,
  },
  {
    path: "/MyAccount/Profile",
    exact: true,
    component: Profile,
    isSecure: true,
  },
  {
    path: "/ChangePassword",
    exact: true,
    component: ChangePassword,
    isSecure: true,
  },
  {
    path: "/ChangePhoneNumber",
    exact: true,
    component: ChangePhoneNumber,
    isSecure: true,
  },
  {
    path: "/ChangeEmailAddress",
    exact: true,
    component: ChangeEmailAddress,
    isSecure: true,
  },
  {
    path: "/contact-us",
    exact: true,
    component: ContactUs,
  },
  {
    path: "/contactus",
    exact: true,
    component: ContactUs,
  },
  {
    path: "/ForgotPassword",
    exact: true,
    component: ForgotPassword,
  },
  {
    path: "/VerifyPassword",
    exact: true,
    component: VerifyPassword,
  },
  {
    path: "/sso",
    exact: true,
    component: VerifyPassword,
  },
  {
    path: "/CuverdSettings",
    exact: true,
    component: CuverdSettings,
    isSecure: true,
  },
  {
    path: "/privacy-policy",
    exact: true,
    component: PrivacyPolicy,
  },
  {
    path: "/terms-and-conditions",
    exact: true,
    component: TermsConditions,
  },
  {
    path: "/aboutus",
    exact: true,
    component: AboutUs,
  },
  {
    path: "/sitemap",
    exact: true,
    component: SiteMap,
  },
  {
    path: "/ForgotVerifyPassword",
    exact: true,
    component: ForgotVerifyPassword,
  },
  {
    path: "/CouponDetailsView",
    exact: true,
    component: SelectedCouponDetails,
    isSecure: true,
  },
  {
    path: "/",
    exact: true,
    component: Home,
  },
];

SAVINGS_ROUTES.push({
  path: "/savings",
  exact: true,
  component: PrescriptionsComponent,
});
SAVINGS_ROUTES.push({
  path: "/savings/:productName/:screenType",
  exact: true,
  component: PrescriptionsComponent,
});

SIGNIN_ROUTES.push({
  path: "/sign-up",
  exact: true,
  component: SignUp,
});
SIGNIN_ROUTES.push({
  path: "/signup",
  exact: true,
  component: SignUp,
});
SIGNIN_ROUTES.push({
  path: "/SignIn",
  exact: true,
  component: SignInView,
});

const version = {
  path: "/version",
  exact: true,
};
CuverdRoutes.push(version);

const RoutingConfig = {};
RoutingConfig[CUVERD] = CuverdRoutes;
RoutingConfig["SIGN_IN"] = SIGNIN_ROUTES;
RoutingConfig["SAVINGS"] = SAVINGS_ROUTES;


export default Object.freeze(RoutingConfig);
